import { IInitialUserState } from 'interfaces/user.interface';

const initialUserState: IInitialUserState = {
  dbUser: null,
  isLoading: false,
  login: () => Promise.resolve(false),
  updateUser: () => Promise.resolve(false),
  updateUserAvatar: () => Promise.resolve(false),
  updateLanguage: () => Promise.resolve(false),
  selectUserSuperAdmin: () => Promise.resolve(false),
};

export default initialUserState;
